module.exports = __webpack_public_path__ + "img/task2_icon1.8c2a8ba1.png";